import { state, style, trigger } from '@angular/animations';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatPaginator } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { OAHelper } from '@app/api/core/utils/helper/offerteantraege-helper';
import { NoDataComponent } from '@app/shared/components/no-data/no-data.component';
import { ReminderComponent } from '@app/shared/components/reminder/reminder.component';
import { FormatAdressPipe } from '@app/shared/pipes/formatadress.pipe';
import { FormatDatePipe } from '@app/shared/pipes/formatdate.pipe';
import { DialogStatus } from '@app/shared/services/ui/dialog/dialog.types';
import { DisplayOption, MessageType } from '@app/shared/services/ui/message/message';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PolizzeResult } from '@o30/entities';
import { EMPTY } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { BasicPolizzeListComponent } from '../basic-polizze-list/basic-polizze-list.component';
import { GenehmigungDetailComponent } from './genehmigung-detail/genehmigung-detail.component';

@UntilDestroy()
@Component({
  selector:    'app-genehmigungen',
  templateUrl: './genehmigungen.component.html',
  styleUrls:   ['./genehmigungen.component.scss'],
  animations:  [
    trigger('detailExpand', [
      state('collapsed', style({
        display: 'none'
      })),
      state('expanded', style({
        height:     '*',
        visibility: 'visible'
      }))
    ])
  ],
  standalone:  true,
  imports:     [
    NgIf,
    MatTable,
    MatSort,
    NgFor,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatIconButton,
    MatIcon,
    MatTooltip,
    ReminderComponent,
    GenehmigungDetailComponent,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgClass,
    MatPaginator,
    MatProgressSpinner,
    NoDataComponent,
    AsyncPipe,
    FormatDatePipe,
    FormatAdressPipe
  ]
})

export class GenehmigungenComponent extends BasicPolizzeListComponent implements OnInit,
                                                                                 OnDestroy {

  get displayedColumns(): string[] {
    const columns = this.tableColumns.map(c => c.columnDef);
    columns.unshift('expand');
    if (this.bearbeitenErlaubt) {
      columns.push('aktionen');
    }
    return columns;
  }

  public saveGenehmigung(row: PolizzeResult): void {
    this.dialogService.displaygenehmigungDialog(row.id, null)
      .afterClosed()
      .pipe(
        switchMap(result => {
          if (result && result.statusId === DialogStatus.SAVE_SUCCESS) {
            return this.dataService.createPolizzeGenehmigung(row.id, result.data);
          }
          return EMPTY;
        }),
        take(1),
        untilDestroyed(this)
      )
      .subscribe(result => {
        this.messageService.handlePayloadReturnSuccess(result, {
          messages:      [
            {
              text: `Genehmigung gespeichert`,
              type: MessageType.INFO,
              icon: 'done'
            }
          ],
          displayOption: DisplayOption.MONITOR
        });
        this.loadList();
      });
  }

  public updateLabel(anzRowsPerEntry = 3, maxViewed = 10): void {
    this.currentPaginationLabel = OAHelper.getPaginationLabel(this.paginator.pageIndex, this.listData.dataSource.filteredData.length, anzRowsPerEntry, maxViewed);
  }

  getAnzRowsPerEntry(): number {
    return 3;
  }
}
